import { LogOut } from "lucide-react";
import { MainNav } from "./main-nav";
import useAuth from "@/contexts/auth/auth-context";

export default function SiteHeader() {
  const { user, logout } = useAuth();

  return (
    <header
      className="flex items-center bg-musio-bg justify-center sticky top-0 z-40 w-full border-b"
      style={{ borderColor: "#2a2a3a" }}
    >
      <div className="w-full flex h-16 items-center justify-between px-6 md:px-8">
        <MainNav />
        <div className="flex items-center gap-4 font-metcon">
          {user &&
            <>
              <p className="font-bold tracking-[-2px]">{user?.contactName}</p>
              <LogOut className="h-6 w-6 hover:cursor-pointer" onClick={logout} />
            </>
          }
        </div>
      </div>
    </header>
  );
}
